import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <main className="mx-auto w-full max-w-2xl px-4 pb-12 pt-5">
      <Link className="rounded text-sm font-medium text-voto-muted hover:text-voto-fg" to="/">
        ‹ Back
      </Link>

      <h1 className="mt-5 text-2xl font-semibold tracking-tight text-white sm:text-3xl">Privacy Policy</h1>
      <p className="mt-1 text-sm text-voto-muted">Effective December 1, 2012</p>

      <div className="mt-6 divide-y divide-voto-line rounded-2xl bg-voto-surface px-5 text-[15px] leading-relaxed text-voto-muted ring-1 ring-voto-line [&>*]:py-5 [&_strong]:block [&_strong]:text-base [&_strong]:font-semibold [&_strong]:text-white">
        <p>
          This Privacy Policy covers votomoto and describes the types of information we gather from
          people visiting votomoto.com or using our service, and how we use such information. By
          using our service you agree to be bound by this Policy.
        </p>

        <section>
          <strong>Information We Collect</strong>
          <p className="mt-2">
            We collect two types of information: personal information (name, email address, etc.)
            that can be used to identify or contact you, and aggregate information (usage patterns,
            browser type, etc.) that cannot be used to identify you individually.
          </p>
        </section>

        <section>
          <strong>How We Use Your Information</strong>
          <p className="mt-2">
            We use information we gather to provide and improve the service, to communicate with
            you about requests you submit, and to provide relevant information to you. We do not
            sell or trade your personal information to unrelated third parties for their own
            marketing purposes.
          </p>
        </section>

        <section>
          <strong>Sharing Your Information</strong>
          <p className="mt-2">
            We may share personal information with third-party service providers as necessary to
            operate the service. We may also share information when required by law, in connection
            with a sale or merger of our business, or when necessary to protect the rights, property,
            or safety of votomoto or others.
          </p>
        </section>

        <section>
          <strong>Cookies</strong>
          <p className="mt-2">
            We use cookies and similar technologies to enhance your experience and understand how
            you use the service. You may disable cookies in your browser settings, though some
            features may not function properly without them.
          </p>
        </section>

        <section>
          <strong>Security</strong>
          <p className="mt-2">
            We take appropriate security measures to protect against unauthorized access to or
            disclosure of your data. No method of transmission over the Internet is 100% secure,
            however, so we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <strong>Children</strong>
          <p className="mt-2">
            Our service is not directed to children under 13. We do not knowingly collect personal
            information from children under 13.
          </p>
        </section>

        <section>
          <strong>Deleting Your Account</strong>
          <p className="mt-2">
            You can permanently delete your account and the polls you've created at any time
            from the app — open your profile and tap <strong>Delete account</strong>. You may
            also email{' '}
            <a href="mailto:eric@ericstevenson.com" className="text-voto-coral hover:underline">
              eric@ericstevenson.com
            </a>{' '}
            to request deletion. Deletion removes your account, your polls, and unlinks your
            votes; it cannot be undone.
          </p>
        </section>

        <section>
          <strong>Changes to This Policy</strong>
          <p className="mt-2">
            We may update this Privacy Policy at any time. Your continued use of the service
            indicates your consent to the then-current Policy.
          </p>
        </section>

        <section>
          <strong>Contact Us</strong>
          <p className="mt-2">
            Questions about this Policy? Email us at{' '}
            <a href="mailto:eric@ericstevenson.com" className="text-voto-coral hover:underline">
              eric@ericstevenson.com
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
